class GtmTrackingHelper {
	// deprecated: will remove before GTM go live. Currently used by Product click work done on BORG-94.
	getRequiredDataAsObject(target, dataMapper) {
		const targetStoreElement = target.hasAttribute(
			'data-gtm-bubble-up-for-data',
		)
			? this.findClosestDataStore(target)
			: target;

		const dataAsObject = [...dataMapper].reduce((accumulator, dataItem) => {
			let defaultVal = dataItem.defaultValue;

			if (defaultVal) {
				defaultVal = this.appendComponentToDefaultValue(
					targetStoreElement,
					defaultVal,
				);
			}

			const gtmKeyValue =
				defaultVal ||
				targetStoreElement.getAttribute(dataItem.dataName) ||
				'undefined';

			accumulator[dataItem.gtmKey] = gtmKeyValue;
			return accumulator;
		}, {});

		return dataAsObject;
	}

	appendComponentToDefaultValue(target, defaultValue) {
		const component = target.getAttribute('data-component');
		const shouldBePatched =
			typeof defaultValue === 'string' &&
			component &&
			!defaultValue.includes(component);

		return shouldBePatched ? `${defaultValue} - ${component}` : defaultValue;
	}

	mapDataViaGtmKey(target, dataMapper, isAjaxData, index) {
		const product = isAjaxData
			? target
			: this.getProductRowFromDataLayer(target);

		if (product) {
			return dataMapper.reduce((accumulator, dataItem) => {
				accumulator[dataItem.gtmKey] = dataItem.useDataValueFrom
					? this.resolveValue(product, dataItem.useDataValueFrom, index)
					: this.resolveValue(product, dataItem.gtmKey, index);

				if (
					'stringManipulations' in dataItem &&
					Array.isArray(dataItem.stringManipulations)
				) {
					dataItem.stringManipulations.forEach(manipulationType => {
						accumulator[dataItem.gtmKey] = this.manipulateString(
							accumulator[dataItem.gtmKey],
							manipulationType,
						);
					});
				}
				return accumulator;
			}, {});
		}
	}

	resolveValue(product, useDataValueFrom, index) {
		const value =
			product[useDataValueFrom] === '' ||
			typeof product[useDataValueFrom] === 'undefined'
				? 'undefined'
				: product[useDataValueFrom];
		return useDataValueFrom === 'indexIterator' && index ? index : value;
	}

	resolveTargetStore(target) {
		return target.hasAttribute('data-gtm-bubble-up-for-data')
			? this.findClosestDataStore(target)
			: target;
	}

	getProductRowFromDataLayer(target) {
		const targetStoreElement = this.resolveTargetStore(target);

		return (
			window.dataLayer[0].basket &&
			window.dataLayer[0].basket.products.find(
				item =>
					item.skuID === targetStoreElement.getAttribute('data-legacy-sku'),
			)
		);
	}

	findClosestClickableElement(target, dataAttribute, type) {
		return target.closest(`a[${dataAttribute}~="${type}"]`);
	}

	findClosestDataStore(target) {
		return target.closest('[data-gtm-data-store="true"]');
	}

	generateActionFieldString(locale, pageType) {
		let localLocale = locale;
		let localPageType = pageType;

		if (window.dataLayer && !locale) {
			localLocale = `${window.dataLayer[0].navigation.countryLocale}`;
		}

		if (window.dataLayer && !pageType) {
			localPageType = `${window.dataLayer[0].navigation.pageType}`;
		}

		return `${localLocale} - ${localPageType}`;
	}

	manipulateString(string, manipulationType) {
		switch (manipulationType) {
			case 'PIPE_TO_SLASH':
				// Convert '|' with possible whitespace (before or after) to '/' without whitespace
				return string.replace(/\s*\|\s*/g, '/');
			case 'REMOVE_SPECIAL_EXCEPT_PIPE':
				return string.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
			case 'TO_LOWERCASE':
				return string.toLowerCase();
			case 'TRIM':
				return string.trim();
			case 'TRUNCATE_AFTER_LAST_PIPE':
				return string.substr(0, string.lastIndexOf('|'));
			case 'WHITESPACE-TO-HYPHEN':
				return string.replace(/\s+/g, '-');
			default:
				return string;
		}
	}
}

const TrackingHelperInstance = new GtmTrackingHelper();
export default TrackingHelperInstance;

// for test purpose only
export const TrackingHelperClass = GtmTrackingHelper;
